import { useTranslation } from 'react-i18next';
import { Button, Modal, Text } from '@shared/widgets';

interface ILockUserModalProps {
  show: boolean;
  onClose: () => void;
  locked: boolean;
  onSave: () => void;
}

export const LockUserModal = (props: ILockUserModalProps) => {
  const { t } = useTranslation('user');

  const lockUnlockHandler = () => {
    props.onSave();
    props.onClose();
  };

  return (
    <Modal
      isOpen={props.show}
      onClose={props.onClose}
      title={t('sidebar.modals.lockUnlock.title', { action: t(`sidebar.modals.lockUnlock.${props.locked ? 'unlock' : 'lock'}`) })}
    >
      <Text>
        {t('sidebar.modals.lockUnlock.description', { action: t(`sidebar.modals.lockUnlock.${props.locked ? 'unlock' : 'lock'}`).toLowerCase() })}
      </Text>
      <div className='mt-6 flex justify-between gap-2'>
        <Button color='outlined' fullWidth onClick={props.onClose}>
          {t('buttons.close', { ns: 'common' })}
        </Button>
        <Button fullWidth color='primary' onClick={lockUnlockHandler}>
          {t(`buttons.${props.locked ? 'unlock' : 'lock'}`, { ns: 'common' })}
        </Button>
      </div>
    </Modal>
  );
};
